import Navbar from './Navbar'
import backgroundImage from '../assets/backgroundImage.webp';
import { APPLICATION_OPEN_DISPLAY } from '../constants/dates';


export const ApplicationsNotOpen = () => {
    return (
        <>
            <Navbar />
            <div style={{ position: 'relative', minHeight: '91vh', overflow: 'hidden' }}>
                {/* Background image */}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundImage: `url(${backgroundImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        filter: 'grayscale(100%)',
                        opacity: 0.15,
                        zIndex: 0
                    }}
                />

                <h1 className="login-title">Welcome to the Sitare University Application Portal!</h1>
                <h2 className="login-title">Admissions open {APPLICATION_OPEN_DISPLAY}.</h2>
                {/* <h4 className="login-title">Visit our <a
                    style={{
                        textDecoration: 'none',
                        color: 'rgb(151, 65, 4)',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                    }}
                    href="https://univ.sitare.org/admissions"
                    target="_blank"
                    rel="noopener noreferrer"
                >FAQ</a> page to learn more about our admissions process.</h4> */}
                <h4 className="login-title">Thank you for your interest.</h4>
            </div>
        </>
    );
};
